"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
// 通用模块错误
var BasicError;
(function (BasicError) {
    BasicError[BasicError["EXTERNAL"] = 1000] = "EXTERNAL";
    BasicError[BasicError["INTERNAL"] = 1001] = "INTERNAL";
})(BasicError = exports.BasicError || (exports.BasicError = {}));
// 注册模块错误
var RegisterError;
(function (RegisterError) {
    RegisterError[RegisterError["REGISTRATION"] = 10000] = "REGISTRATION";
    RegisterError[RegisterError["USER_ALREADY_BOUND_MOBILE"] = 10001] = "USER_ALREADY_BOUND_MOBILE";
    RegisterError[RegisterError["MOBILE_BOUND_BY_OTHER_USER"] = 10002] = "MOBILE_BOUND_BY_OTHER_USER";
    RegisterError[RegisterError["ACCOUNT_MERGE_HAS_CONFLICTS"] = 10003] = "ACCOUNT_MERGE_HAS_CONFLICTS";
    RegisterError[RegisterError["USER_ENROLLMENT_CONFLICT"] = 10004] = "USER_ENROLLMENT_CONFLICT";
    RegisterError[RegisterError["VALIDTE_CODE_ERROR"] = 10005] = "VALIDTE_CODE_ERROR";
})(RegisterError = exports.RegisterError || (exports.RegisterError = {}));
// 授权模块错误
var AuthorizationError;
(function (AuthorizationError) {
    AuthorizationError[AuthorizationError["AUTHORIZATION"] = 20000] = "AUTHORIZATION";
    AuthorizationError[AuthorizationError["TOKEN_EXPIRED_OR_INVALID"] = 20001] = "TOKEN_EXPIRED_OR_INVALID";
    AuthorizationError[AuthorizationError["INVALID_SMS_CODE"] = 20002] = "INVALID_SMS_CODE";
    AuthorizationError[AuthorizationError["DEVICE_UNBIND"] = 20003] = "DEVICE_UNBIND";
    AuthorizationError[AuthorizationError["REACHE_MAX_DEVICES"] = 20004] = "REACHE_MAX_DEVICES";
    AuthorizationError[AuthorizationError["OPENID_NOT_FOUND"] = 20005] = "OPENID_NOT_FOUND";
})(AuthorizationError = exports.AuthorizationError || (exports.AuthorizationError = {}));
// CRUD
var CrudCodeError;
(function (CrudCodeError) {
    CrudCodeError[CrudCodeError["CRUD"] = 30000] = "CRUD";
    CrudCodeError[CrudCodeError["ALREADY_EXISTS"] = 30001] = "ALREADY_EXISTS";
    CrudCodeError[CrudCodeError["INVALID_VALUE"] = 30002] = "INVALID_VALUE";
})(CrudCodeError = exports.CrudCodeError || (exports.CrudCodeError = {}));
// 绑定模块错误
var InventoryError;
(function (InventoryError) {
    InventoryError[InventoryError["INVENTORY"] = 40000] = "INVENTORY";
    InventoryError[InventoryError["SKU_OUT_OF_STOCK"] = 40001] = "SKU_OUT_OF_STOCK";
    InventoryError[InventoryError["SKU_NOT_AVAILABLE"] = 40002] = "SKU_NOT_AVAILABLE";
    InventoryError[InventoryError["SKU_NOT_MEET_PURCHASE_RESTRICTIONS"] = 40003] = "SKU_NOT_MEET_PURCHASE_RESTRICTIONS";
})(InventoryError = exports.InventoryError || (exports.InventoryError = {}));
// 商品模块错误
var ProductError;
(function (ProductError) {
    ProductError[ProductError["PRODUCT"] = 50000] = "PRODUCT";
    ProductError[ProductError["SPECIFICATION_PARAMS_ERROR"] = 50001] = "SPECIFICATION_PARAMS_ERROR";
    ProductError[ProductError["COMPLETED_LESSON_CONSTRAINT_ERROR"] = 50002] = "COMPLETED_LESSON_CONSTRAINT_ERROR";
    ProductError[ProductError["BEFORE_COMPLETE_COURSE_CONSTRAINT_ERROR"] = 50003] = "BEFORE_COMPLETE_COURSE_CONSTRAINT_ERROR";
    ProductError[ProductError["REACHED_LIMITED_AMOUNT_ERROR"] = 50004] = "REACHED_LIMITED_AMOUNT_ERROR";
    ProductError[ProductError["DISABLE_EXCHANGE_ERROR"] = 50005] = "DISABLE_EXCHANGE_ERROR";
    ProductError[ProductError["AFTER_STARTED_COURSE_CONSTRAINT_ERROR"] = 50006] = "AFTER_STARTED_COURSE_CONSTRAINT_ERROR";
    ProductError[ProductError["SLM_CONSTRAINT_ERROR"] = 50007] = "SLM_CONSTRAINT_ERROR";
})(ProductError = exports.ProductError || (exports.ProductError = {}));
// enrollment
var EnrollmentError;
(function (EnrollmentError) {
    EnrollmentError[EnrollmentError["ENROLLMENT"] = 60000] = "ENROLLMENT";
    EnrollmentError[EnrollmentError["ENROLLMENT_NOT_FOUND_ERROR"] = 60001] = "ENROLLMENT_NOT_FOUND_ERROR";
    EnrollmentError[EnrollmentError["NO_TEACHER_AVAILABLE"] = 60002] = "NO_TEACHER_AVAILABLE";
})(EnrollmentError = exports.EnrollmentError || (exports.EnrollmentError = {}));
// 领取优惠券模块错误
var GroupSaleError;
(function (GroupSaleError) {
    GroupSaleError[GroupSaleError["GROUP_SALE"] = 70000] = "GROUP_SALE";
    GroupSaleError[GroupSaleError["GROUP_SALE_NOT_ACTIVE"] = 70001] = "GROUP_SALE_NOT_ACTIVE";
    GroupSaleError[GroupSaleError["GROUP_SALE_HAS_NOT_STARTED"] = 70002] = "GROUP_SALE_HAS_NOT_STARTED";
    GroupSaleError[GroupSaleError["GROUP_SALE_HAS_ENDED"] = 70003] = "GROUP_SALE_HAS_ENDED";
    GroupSaleError[GroupSaleError["GROUP_PURCHASE_INVALID"] = 70004] = "GROUP_PURCHASE_INVALID";
    GroupSaleError[GroupSaleError["ALREADY_JOINED_SAME_GROUP_PURCHASE_AND_IS_FULL"] = 70005] = "ALREADY_JOINED_SAME_GROUP_PURCHASE_AND_IS_FULL";
    GroupSaleError[GroupSaleError["ALREADY_JOINED_OTHER_GROUP_PURCHASE"] = 70006] = "ALREADY_JOINED_OTHER_GROUP_PURCHASE";
    GroupSaleError[GroupSaleError["NOT_MEET_SKUS_PURCHASE_RESTRICTIONS"] = 70007] = "NOT_MEET_SKUS_PURCHASE_RESTRICTIONS";
    GroupSaleError[GroupSaleError["ALREADY_JOINED_SAME_GROUP_PURCHASE"] = 70008] = "ALREADY_JOINED_SAME_GROUP_PURCHASE";
    GroupSaleError[GroupSaleError["NEW_USERS_ONLY"] = 70009] = "NEW_USERS_ONLY";
    GroupSaleError[GroupSaleError["NOT_ALLOWED_CANCEL_GROUP_PURCHASE"] = 70010] = "NOT_ALLOWED_CANCEL_GROUP_PURCHASE";
    GroupSaleError[GroupSaleError["GROUP_PHURSE_NOT_FOUND"] = 70011] = "GROUP_PHURSE_NOT_FOUND";
})(GroupSaleError = exports.GroupSaleError || (exports.GroupSaleError = {}));
var SlmError;
(function (SlmError) {
    SlmError[SlmError["SLM"] = 80000] = "SLM";
    SlmError[SlmError["SLM_RELATIONSHIP_STATUS_INCORRECT"] = 80001] = "SLM_RELATIONSHIP_STATUS_INCORRECT";
    SlmError[SlmError["SLM_NOT_FOUND"] = 80002] = "SLM_NOT_FOUND";
    SlmError[SlmError["INVITER_HAS_NO_PAID_TAG"] = 80003] = "INVITER_HAS_NO_PAID_TAG";
    SlmError[SlmError["USER_HAS_PAID_TAG"] = 80004] = "USER_HAS_PAID_TAG";
    SlmError[SlmError["USER_HAS_FUNDED_RELATIONSHIP"] = 80005] = "USER_HAS_FUNDED_RELATIONSHIP";
    SlmError[SlmError["SLM_INACTIVE"] = 80006] = "SLM_INACTIVE";
    SlmError[SlmError["SLM_CUSTOM_CONTENT"] = 80007] = "SLM_CUSTOM_CONTENT";
})(SlmError = exports.SlmError || (exports.SlmError = {}));
// 兑换码模块错误
var RedeemCodeError;
(function (RedeemCodeError) {
    RedeemCodeError[RedeemCodeError["REDEEM_CODE"] = 90000] = "REDEEM_CODE";
    RedeemCodeError[RedeemCodeError["REDEEM_CODE_IS_INVALID"] = 90001] = "REDEEM_CODE_IS_INVALID";
    RedeemCodeError[RedeemCodeError["REDEEM_CODE_HAS_USED"] = 90002] = "REDEEM_CODE_HAS_USED";
    RedeemCodeError[RedeemCodeError["REDEEM_CODE_HAS_DESTROY"] = 90003] = "REDEEM_CODE_HAS_DESTROY";
    RedeemCodeError[RedeemCodeError["REDEEM_CODE_HAS_EXPIRED"] = 90004] = "REDEEM_CODE_HAS_EXPIRED";
})(RedeemCodeError = exports.RedeemCodeError || (exports.RedeemCodeError = {}));
exports.ErrorTips = (_a = {},
    // REGISTRATION
    _a[RegisterError.USER_ENROLLMENT_CONFLICT] = '用户已购买该课程',
    _a[RegisterError.VALIDTE_CODE_ERROR] = '验证码错误',
    _a[RegisterError.MOBILE_BOUND_BY_OTHER_USER] = '该手机号已注册，请不要重复注册哦',
    _a[RegisterError.USER_ALREADY_BOUND_MOBILE] = '该手机号已注册，请不要重复注册哦',
    _a[RegisterError.ACCOUNT_MERGE_HAS_CONFLICTS] = '账户合并有冲突',
    // AUTHORIZATION
    _a[AuthorizationError.TOKEN_EXPIRED_OR_INVALID] = 'token失效',
    _a[AuthorizationError.INVALID_SMS_CODE] = '无效码',
    _a[AuthorizationError.DEVICE_UNBIND] = '账号未绑定',
    _a[AuthorizationError.REACHE_MAX_DEVICES] = '绑定设备已到最大限度',
    _a[AuthorizationError.OPENID_NOT_FOUND] = '找不到openId',
    // CRUD
    _a[CrudCodeError.ALREADY_EXISTS] = '已存在',
    _a[CrudCodeError.INVALID_VALUE] = '无效值',
    // INVENTORY
    _a[InventoryError.SKU_OUT_OF_STOCK] = '库存不足',
    _a[InventoryError.SKU_NOT_AVAILABLE] = '无效sku',
    _a[InventoryError.SKU_NOT_MEET_PURCHASE_RESTRICTIONS] = '不满足购买sku条件',
    // PRODUCT
    _a[ProductError.SPECIFICATION_PARAMS_ERROR] = '商品参数错误',
    _a[ProductError.COMPLETED_LESSON_CONSTRAINT_ERROR] = '没有完成课程',
    _a[ProductError.BEFORE_COMPLETE_COURSE_CONSTRAINT_ERROR] = '暂未开课',
    _a[ProductError.REACHED_LIMITED_AMOUNT_ERROR] = '商品已达上线',
    _a[ProductError.DISABLE_EXCHANGE_ERROR] = '不能修改',
    _a[ProductError.AFTER_STARTED_COURSE_CONSTRAINT_ERROR] = '不满足开课条件',
    _a[ProductError.SLM_CONSTRAINT_ERROR] = '不满足分销条件',
    // GROUP_SALE
    _a[GroupSaleError.GROUP_SALE_NOT_ACTIVE] = '团购活动已结束',
    _a[GroupSaleError.GROUP_SALE_HAS_NOT_STARTED] = '团购未开始',
    _a[GroupSaleError.GROUP_SALE_HAS_ENDED] = '团购已结束',
    _a[GroupSaleError.ALREADY_JOINED_SAME_GROUP_PURCHASE_AND_IS_FULL] = '当前拼团人数已满',
    _a[GroupSaleError.ALREADY_JOINED_OTHER_GROUP_PURCHASE] = '已经参加其他拼团',
    _a[GroupSaleError.NOT_MEET_SKUS_PURCHASE_RESTRICTIONS] = '不满足拼团条件',
    // SLM
    _a[SlmError.SLM_RELATIONSHIP_STATUS_INCORRECT] = '分销状态错误',
    _a[SlmError.SLM_NOT_FOUND] = '分销不存在',
    _a[SlmError.INVITER_HAS_NO_PAID_TAG] = '邀请者没有付费标签',
    _a[SlmError.USER_HAS_PAID_TAG] = '用户已经购买过',
    _a[SlmError.USER_HAS_FUNDED_RELATIONSHIP] = '用户已经存在绑定关系',
    _a[SlmError.SLM_INACTIVE] = '分销活动未开启',
    _a[SlmError.SLM_CUSTOM_CONTENT] = '',
    // RedeemCode
    _a[RedeemCodeError.REDEEM_CODE_IS_INVALID] = '兑换码无效',
    _a[RedeemCodeError.REDEEM_CODE_HAS_USED] = '兑换码已使用',
    _a[RedeemCodeError.REDEEM_CODE_HAS_DESTROY] = '兑换码已经被销毁',
    _a[RedeemCodeError.REDEEM_CODE_HAS_EXPIRED] = '已超过兑换时间',
    _a);
function getErrorMessage(e) {
    var _a = e.response.data, code = _a.code, message = _a.message;
    if (!code) {
        return;
    }
    if (exports.ErrorTips[code]) {
        return exports.ErrorTips;
    }
    if (!message) {
        return;
    }
    return message;
}
exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=errorType.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/errorType.js
// module id = 1013
// module chunks = 0